import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { CompaniesService } from "../companies/companies.service";
import { ConfigService } from "../config.service";

@Injectable()
export class ApiService {
  static projects: any[];
  static employers: any[];
  title = "Insite Admin";

  static getCountryNames(countryCodes: string[]): string[] {
    let names = [];
    if (countryCodes) {
      countryCodes.map((countryCode) => {
        let countries = ConfigService.countryList.filter((it) => {
          return it.code === countryCode;
        });
        if (countries.length > 0) {
          names.push(countries[0].name);
        }
      });
    }
    return names;
  }

  static getLanguageNames(languageCodes: string[]): string[] {
    let names = [];
    languageCodes.map((key) => {
      let languages = ConfigService.languages.filter((it) => {
        return it.key === key;
      });
      if (languages.length > 0) {
        names.push(languages[0].value);
      }
    });
    return names;
  }

  static getItemsPerPage(): number {
    try {
      let num = Number.parseInt(localStorage.getItem("itemsPerPage"));
      if (!num) {
        return 10;
      }
      return num;
    } catch (ex) {
      return 10;
    }
  }

  static saveItemsPerPage(value: number) {
    try {
      localStorage.setItem("itemsPerPage", value.toString());
    } catch (ex) {}
  }

  constructor(private http: Http, private companiesService: CompaniesService) {}
}

// https://angular.io/docs/ts/latest/guide/server-communication.html#!#http-client



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/api.service.ts